








import Vue, { PropType } from 'vue'

import { Widget } from '../base'

export default Vue.extend({
  props: {
    widget: {
      type: Object as PropType<Widget>,
      required: true
    }
  },
  computed: {
    headlineCssClasses() {
      const textAlign = this.widget.customSettings.settings.textAlign.value
      const fontSize = this.widget.customSettings.settings.fontSize.value
      return {
        'center': textAlign === '1',
        'right': textAlign === '2',
        'xl': fontSize === '1',
        'xxl': fontSize === '2'
      }
    }
  }
})
